module.exports = __webpack_public_path__ + "62zMRbUQkDDyPCw-E/icon_info.svg";